import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { Tag } from "@/components/ui/tag"
import { BetterDocExchangeLink } from "@/modules/admin/better-doc/components/better-doc-exchange-link"
import { BetterDocField } from "@/modules/admin/better-doc/components/better-doc-field"
import { formatBetterDocRecommendationState } from "@/modules/admin/better-doc/lib/better-doc-enum-label"
import { formatBetterDocValue } from "@/modules/admin/better-doc/lib/format-better-doc-value"
import { BetterDocSessionActionOutcome } from "@/modules/admin/better-doc/types/BetterDocSessionActionOutcome"

type BetterDocSessionActionResultProps = {
  outcome: BetterDocSessionActionOutcome
}

export const BetterDocSessionActionResult = ({ outcome }: BetterDocSessionActionResultProps) => {
  const { t } = useTranslation()
  const { result, errorMessages } = outcome

  return (
    <div className="flex flex-col gap-4" data-testid="better-doc-admin-session-action-result">
      {errorMessages.map((errorMessage) => (
        <Banner key={errorMessage} type="inline" variant="critical" data-testid="better-doc-admin-session-action-error">
          {errorMessage}
        </Banner>
      ))}
      {result === null ? null : (
        <div className="grid grid-cols-3 gap-4">
          <BetterDocField
            label={t("admin.betterDoc.actionResult.outcome")}
            value={
              <Tag
                type={result.isSuccessful ? "success" : "critical"}
                label={
                  result.isSuccessful
                    ? t("admin.betterDoc.actionResult.successful")
                    : t("admin.betterDoc.actionResult.failed")
                }
              />
            }
            testId="better-doc-admin-session-action-result-outcome"
          />
          <BetterDocField
            label={t("admin.betterDoc.actionResult.httpStatusCode")}
            value={formatBetterDocValue(result.httpStatusCode)}
            testId="better-doc-admin-session-action-result-status-code"
          />
          <BetterDocField
            label={t("admin.betterDoc.actionResult.betterDocState")}
            value={formatBetterDocRecommendationState(t, result.betterDocState)}
            testId="better-doc-admin-session-action-result-state"
          />
          <BetterDocField
            label={t("admin.betterDoc.actionResult.caseId")}
            value={formatBetterDocValue(result.caseId)}
            testId="better-doc-admin-session-action-result-case-id"
          />
          <BetterDocField
            label={t("admin.betterDoc.actionResult.errorReason")}
            value={formatBetterDocValue(result.errorReason)}
            testId="better-doc-admin-session-action-result-error-reason"
          />
          {result.exchangeId === null ? null : (
            <div className="flex items-end">
              <BetterDocExchangeLink exchangeId={result.exchangeId} />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
